/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Component spacing variables */
  --calcite-icon-size: 1rem;
  --calcite-spacing-eighth: 0.125rem;
  --calcite-spacing-quarter: 0.25rem;
  --calcite-spacing-half: 0.5rem;
  --calcite-spacing-three-quarters: 0.75rem;
  --calcite-spacing: 1rem;
  --calcite-spacing-plus-quarter: 1.25rem;
  --calcite-spacing-plus-half: 1.5rem;
  --calcite-spacing-double: 2rem;
  --calcite-menu-min-width: 10rem;
  --calcite-header-min-height: 3rem;
  --calcite-footer-min-height: 3rem;
}

:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  position: relative;
  display: inline-block;
  inline-size: 100%;
  overflow: visible;
  vertical-align: top;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:host .menu-container .calcite-floating-ui-anim {
  position: relative;
  transition: var(--calcite-floating-ui-transition);
  transition-property: inset, left, opacity;
  opacity: 0;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
  z-index: var(--calcite-z-index);
  border-radius: 0.25rem;
}
:host .menu-container[data-placement^=bottom] .calcite-floating-ui-anim {
  inset-block-start: -5px;
}
:host .menu-container[data-placement^=top] .calcite-floating-ui-anim {
  inset-block-start: 5px;
}
:host .menu-container[data-placement^=left] .calcite-floating-ui-anim {
  left: 5px;
}
:host .menu-container[data-placement^=right] .calcite-floating-ui-anim {
  left: -5px;
}
:host .menu-container[data-placement] .calcite-floating-ui-anim--active {
  opacity: 1;
  inset-block: 0;
  left: 0;
}

:host([scale=s]) {
  --calcite-toggle-spacing: 0.5rem;
  --calcite-internal-input-text-input-padding-inline-end: calc(var(--calcite-toggle-spacing) + 1rem);
}

:host([scale=m]) {
  --calcite-toggle-spacing: 0.75rem;
  --calcite-internal-input-text-input-padding-inline-end: calc(var(--calcite-toggle-spacing) + 1.5rem);
}

:host([scale=l]) {
  --calcite-toggle-spacing: 1rem;
  --calcite-internal-input-text-input-padding-inline-end: calc(var(--calcite-toggle-spacing) + 2rem);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

.calendar-wrapper {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transform: translate3d(0, 0, 0);
}

.input-wrapper {
  position: relative;
}
.input-wrapper .chevron-icon {
  color: var(--calcite-color-text-3);
}
.input-wrapper:focus-within .chevron-icon, .input-wrapper:active .chevron-icon, .input-wrapper:hover .chevron-icon {
  color: var(--calcite-color-text-1);
}

.toggle-icon {
  position: absolute;
  display: flex;
  cursor: pointer;
  align-items: center;
  inset-inline-end: 0;
  inset-block: 0;
  padding-inline: var(--calcite-toggle-spacing);
}

:host([range]) .input-container {
  display: flex;
}
:host([range]) .input-wrapper {
  flex: 1 1 auto;
}
:host([range]) .horizontal-arrow-container {
  display: flex;
  align-items: center;
  border-width: 1px;
  border-inline-start-width: 0px;
  border-inline-end-width: 0px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  background-color: var(--calcite-color-background);
  padding-block: 0px;
  padding-inline: 0.25rem;
}

:host([range][layout=vertical]) .input-wrapper {
  inline-size: 100%;
}
:host([range][layout=vertical]) .input-container {
  flex-direction: column;
  align-items: flex-start;
}
:host([range][layout=vertical]) .calendar-wrapper--end {
  transform: translate3d(0, 0, 0);
}
:host([range][layout=vertical]) .vertical-arrow-container {
  inset-block-start: 1.5rem;
  position: absolute;
  z-index: var(--calcite-z-index);
  margin-inline: 1px;
  background-color: var(--calcite-color-foreground-1);
  padding-inline: 0.625rem;
  inset-inline-start: 0;
}

.menu-container {
  --calcite-floating-ui-z-index: var(--calcite-z-index-dropdown);
  display: block;
  position: absolute;
  z-index: var(--calcite-floating-ui-z-index);
  visibility: hidden;
}

.menu-container .calcite-floating-ui-anim {
  position: relative;
  transition: var(--calcite-floating-ui-transition);
  transition-property: inset, left, opacity;
  opacity: 0;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
  z-index: var(--calcite-z-index);
  border-radius: 0.25rem;
}
.menu-container[data-placement^=bottom] .calcite-floating-ui-anim {
  inset-block-start: -5px;
}
.menu-container[data-placement^=top] .calcite-floating-ui-anim {
  inset-block-start: 5px;
}
.menu-container[data-placement^=left] .calcite-floating-ui-anim {
  left: 5px;
}
.menu-container[data-placement^=right] .calcite-floating-ui-anim {
  left: -5px;
}
.menu-container[data-placement] .calcite-floating-ui-anim--active {
  opacity: 1;
  inset-block: 0;
  left: 0;
}

:host([open]) .menu-container {
  visibility: visible;
}

.menu-container--active {
  visibility: visible;
}

.input .calcite-input__wrapper {
  margin-block-start: 0px;
}

:host([range][layout=vertical][scale=m]) .vertical-arrow-container {
  inset-block-start: 1.5rem;
  padding-inline-start: 0.75rem;
}
:host([range][layout=vertical][scale=m]) .vertical-arrow-container calcite-icon {
  block-size: 0.75rem;
  inline-size: 0.75rem;
  min-inline-size: 0px;
}

:host([range][layout=vertical][scale=l]) .vertical-arrow-container {
  inset-block-start: 2.25rem;
  padding-inline: 0.875rem;
}

:host([range][layout=vertical][open]) .vertical-arrow-container {
  display: none;
}

.validation-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

:host([scale=m]) .validation-container,
:host([scale=l]) .validation-container {
  padding-block-start: 0.5rem;
}

:host([scale=s]) .validation-container {
  padding-block-start: 0.25rem;
}

::slotted(input[slot=hidden-form-input]) {
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  position: absolute !important;
  inset: 0 !important;
  transform: none !important;
  -webkit-appearance: none !important;
  z-index: -1 !important;
}

.assistive-text {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}